import { ApiExplanatoryVideoCategoryUseCases } from "~/data/usecases/explanatory-video-category/api-explanatory-video-category";
import { makeHttpClient } from "~/main/factories/infra/http-client";

export const makeExplanatoryVideoCategoryUseCases = () => {
  return new ApiExplanatoryVideoCategoryUseCases(makeHttpClient());
};
